






























































































































































import i18n from "@/libs/i18n";
import { useTagsStore } from "@/store/useTagsStore";
import { styleByColor } from "@/utils/color";
import { Tag } from "@saysimple-platform/dtos";
// @ts-ignore
import { required } from "@validations";
import { PropOptions, Ref, ref, SetupContext } from "@vue/composition-api";
import {
    BBadge,
    BButton,
    BCol,
    BContainer,
    BForm,
    BFormGroup,
    BFormInput,
    BLink,
    BModal,
    BPopover,
    BRow,
    BSpinner,
    BTable,
} from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { useToast } from "vue-toastification/composition";

export default {
    components: {
        BBadge,
        BButton,
        BCol,
        BContainer,
        BForm,
        BFormGroup,
        BFormInput,
        BLink,
        BModal,
        BPopover,
        BRow,
        BSpinner,
        BTable,
        ValidationObserver,
        ValidationProvider,
    },
    setup(_: PropOptions, context: SetupContext) {
        const toast = useToast();
        const showModal = ref(false);
        const searchQuery = ref("");

        const { fetchTags, isLoadingTags, isLoadingTag } = useTagsStore();
        const { tags } = storeToRefs(useTagsStore());

        fetchTags();

        const tag: Ref<Tag> = ref({
            id: undefined,
            name: "",
            color: "#3b70ff",
        });

        const submit = () => {
            if (tag.value.id) {
                updateTag(tag.value.id, tag.value).then(() => (showModal.value = false));
            } else {
                createTag().then(() => (showModal.value = false));
            }
        };

        const reset = () => {
            tag.value = {
                id: undefined,
                name: "",
                color: "#3b70ff",
            };
        };

        const showTagModal = (inputTag) => {
            showModal.value = true;
            // i use the spread operator to make a copy of the tag because if the change fails on backend side
            // they will be presents on the tag table that can create a confusion for the user
            tag.value = { ...inputTag };
        };

        const createTag = () => {
            const { createTag } = useTagsStore();

            return createTag(tag.value)
                .then((result) => {
                    toast.success(i18n.t("toast.create.success", { entity: i18n.t("settings.tags.Tag") }));

                    return result;
                })
                .catch((e) => {
                    toast.error(i18n.t("toast.create.error", { entity: i18n.t("settings.tags.Tag") }));

                    throw e;
                });
        };

        const updateTag = (tagId: number, tag: Partial<Tag>) => {
            const { updateTag } = useTagsStore();

            return updateTag(tagId, tag)
                .then((result) => {
                    toast.success(i18n.t("toast.update.success", { entity: i18n.t("settings.tags.Tag") }));

                    return result;
                })
                .catch((e) => {
                    toast.error(i18n.t("toast.update.error", { entity: i18n.t("settings.tags.Tag") }));

                    throw e;
                });
        };

        const deleteTag = (tagId) => {
            context.root.$bvModal
                .msgBoxConfirm(i18n.t("confirm.Are you sure?"), {
                    title: i18n.t("confirm.Are you sure?"),
                    cancelTitle: i18n.t("confirm.Cancel"),
                    cancelVariant: "light",
                    okTitle: i18n.t("confirm.Yes, delete"),
                    hideHeaderClose: false,
                    headerCloseVariant: "light",
                    centered: true,
                    bodyClass: "mx-auto",
                    headerClass: "text-center",
                })
                .then((result) => {
                    if (result) {
                        const { deleteTag } = useTagsStore();

                        return deleteTag(tagId)
                            .then((res) => {
                                toast.success(i18n.t("toast.delete.success", { entity: i18n.t("settings.tags.Tag") }));

                                return res;
                            })
                            .catch(() =>
                                toast.error(i18n.t("toast.delete.error", { entity: i18n.t("settings.tags.Tag") }))
                            );
                    }
                });
        };

        const popoverShow = ref(false);

        const onPopoverClose = () => {
            popoverShow.value = false;
        };

        const tableColumns = [
            {
                key: "name",
                label: "Name",
                sortable: true,
            },
            {
                key: "color",
                label: "Color",
                sortable: true,
            },
            {
                key: "actions",
                label: "Actions",
            },
        ];

        const validator = ref<InstanceType<typeof ValidationObserver>>();
        return {
            deleteTag,
            isLoadingTag,
            isLoadingTags,
            onPopoverClose,
            popoverShow,
            required,
            reset,
            searchQuery,
            showModal,
            showTagModal,
            styleByColor,
            submit,
            tableColumns,
            tag,
            tags,
            validator,
        };
    },
};
